import React from "react";
import {Image} from "react-bootstrap";

export default function Solution({solution}) {
    const {title, methods, description, link, image} = solution;

    const renderMethods = () => {
        if (methods) {
            return (
                <>
                    <h4 className="headline headline__pharma_small_blue_uppercase">
                        Methods:
                    </h4>
                    <ul className="typography__caption">
                        {methods.split("\n").map((str, index) => (
                            <li key={index}>{str}</li>
                        ))}
                    </ul>
                </>
            );
        }
    }

    const renderDescriptions = () => {
        if (description) {
            return (
                <>
                    <h4 className="headline headline__pharma_small_blue_uppercase">
                        Your benefits:
                    </h4>
                    <ul className="typography__caption">
                        {description.split("\n").map((str, index) => (
                            <li key={index}>{str}</li>
                        ))}
                    </ul>
                </>
            );
        }
    }

    return (
        <div className="solution-sliders inner">
            <h2>{title}</h2>
            <Image
                className="d-block w-100 image-class-name mb-3"
                src={require("../img/solutions/" + image).default}
                alt={title}
            />
            <div className="benefits-intro">
                {renderMethods()}
            </div>
            <div className="benefits-intro">
                {renderDescriptions()}
            </div>
            <div className="text-center mt-2">
                <a
                    href={link}
                    target="_blank"
                    className="button button__secondary button__flags --small typography__copyText d-inline-flex"
                    rel="noreferrer"
                >
                    Learn more
                </a>
            </div>
        </div>
    );
}
